import { StyleSheet } from 'react-native';
import { BUTTON_STATE, BUTTON_THEME, BUTTON_TYPE } from '../constants';
import colors from '../../../colors';

// #region Styling Theme
export const getStyleTheme = (theme, themeType, status) => ({
  buttonText: styles[`${theme}-${themeType}_${status}_buttonText`],
  buttonContainer: styles[`${theme}-${themeType}_${status}_buttonContainer`]
});
export const addButtonTheme = (theme, themeType, status, styleList) => {
  const [textColor, buttonColor, borderColor] = styleList;
  return {
    [`${theme}-${themeType}_${status}_buttonText`]: {
      color: textColor
    },
    [`${theme}-${themeType}_${status}_buttonContainer`]: {
      backgroundColor: buttonColor,
      borderColor,
      borderWidth: borderColor ? 1 : undefined
    }
  };
};
export const styles = StyleSheet.create({
  buttonContainerSmall: {
    minHeight: 36,
    minWidth: 88,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    borderRadius: 4,
    marginVertical: 6
    // boxShadow: 'rgba(0, 0, 0, 0.15) 0px 25px 100px',
  },
  buttonContainerNormal: {
    minHeight: 48,
    minWidth: 88,
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 20,
    borderRadius: 4
  },
  buttonTextSmall: {
    fontSize: 15
  },
  buttonTextNormal: {
    fontSize: 17
  },
  /* primary-tosca */
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DEFAULT, [colors.C_WHITE_100, colors.C_SECONDARY_TOSCA_4]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.PRIMARY, BUTTON_STATE.HOVER, [colors.C_WHITE_100, colors.C_PRIMARY_TOSCA]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.PRIMARY, BUTTON_STATE.SELECTED, [colors.C_WHITE_100, colors.C_SECONDARY_TOSCA_5]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_BLACK_5]),
  /* primary-teal */
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DEFAULT, [colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.PRIMARY, BUTTON_STATE.HOVER, [colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.PRIMARY, BUTTON_STATE.SELECTED, [colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_BLACK_5]),
  /* primary-red */
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DEFAULT, [colors.C_WHITE_100, colors.C_PRIMARY_RED]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.PRIMARY, BUTTON_STATE.HOVER, [colors.C_WHITE_100, colors.C_PRIMARY_RED]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.PRIMARY, BUTTON_STATE.SELECTED, [colors.C_WHITE_100, colors.C_SECONDARY_RED_5]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_BLACK_5]),
  /* primary-black */
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DEFAULT, [colors.C_WHITE_100, colors.C_BLACK_90]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.PRIMARY, BUTTON_STATE.HOVER, [colors.C_WHITE_100, colors.C_BLACK_80]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.PRIMARY, BUTTON_STATE.SELECTED, [colors.C_WHITE_100, colors.C_BLACK_100]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.PRIMARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_BLACK_5]),
  /* secondary-tosca */
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DEFAULT, [colors.C_SECONDARY_TOSCA_4, colors.C_WHITE_100, colors.C_SECONDARY_TOSCA_4]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.SECONDARY, BUTTON_STATE.HOVER, [colors.C_PRIMARY_TOSCA, colors.C_WHITE_100, colors.C_PRIMARY_TOSCA]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.SECONDARY, BUTTON_STATE.SELECTED, [colors.C_SECONDARY_TOSCA_4, colors.C_SECONDARY_TOSCA_1, colors.C_SECONDARY_TOSCA_4]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100, colors.C_BLACK_30]),
  /* secondary-teal */
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DEFAULT, [colors.C_TEAL_500, colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.SECONDARY, BUTTON_STATE.HOVER, [colors.C_TEAL_500, colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.SECONDARY, BUTTON_STATE.SELECTED, [colors.C_TEAL_500, colors.C_WHITE_100, colors.C_TEAL_500]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100, colors.C_BLACK_30]),
  /* secondary-black */
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DEFAULT, [colors.C_BLACK_90, colors.C_WHITE_100, colors.C_BLACK_90]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.SECONDARY, BUTTON_STATE.HOVER, [colors.C_BLACK_80, colors.C_WHITE_100, colors.C_BLACK_80]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.SECONDARY, BUTTON_STATE.SELECTED, [colors.C_BLACK_90, colors.C_SECONDARY_TOSCA_1, colors.C_BLACK_90]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100, colors.C_BLACK_30]),
  /* secondary-red */
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DEFAULT, [colors.C_SECONDARY_RED_4, colors.C_WHITE_100, colors.C_SECONDARY_RED_4]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.SECONDARY, BUTTON_STATE.HOVER, [colors.C_PRIMARY_RED, colors.C_WHITE_100, colors.C_PRIMARY_RED]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.SECONDARY, BUTTON_STATE.SELECTED, [colors.C_BLACK_90, colors.C_SECONDARY_RED_1, colors.C_BLACK_90]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.SECONDARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100, colors.C_BLACK_30]),
  /* tertiary-tosca */
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DEFAULT, [colors.C_SECONDARY_TOSCA_4, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.TERTIARY, BUTTON_STATE.HOVER, [colors.C_PRIMARY_TOSCA, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.TERTIARY, BUTTON_STATE.SELECTED, [colors.C_SECONDARY_TOSCA_5, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TOSCA, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100]),
  /* tertiary-teal */
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DEFAULT, [colors.C_TEAL_500, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.TERTIARY, BUTTON_STATE.HOVER, [colors.C_TEAL_500, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.TERTIARY, BUTTON_STATE.SELECTED, [colors.C_TEAL_500, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.TEAL, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100]),
  /* tertiary-black */
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DEFAULT, [colors.C_BLACK_90, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.TERTIARY, BUTTON_STATE.HOVER, [colors.C_PRIMARY_TOSCA, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.TERTIARY, BUTTON_STATE.SELECTED, [colors.C_SECONDARY_TOSCA_5, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.BLACK, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100]),
  /* tertiary-grey */
  ...addButtonTheme(BUTTON_THEME.GREY, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DEFAULT, [colors.C_BLACK_60, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.GREY, BUTTON_TYPE.TERTIARY, BUTTON_STATE.HOVER, [colors.C_BLACK_80, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.GREY, BUTTON_TYPE.TERTIARY, BUTTON_STATE.SELECTED, [colors.C_BLACK_100, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.GREY, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100]),
  /* tertiary-red */
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DEFAULT, [colors.C_SECONDARY_RED_4, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.TERTIARY, BUTTON_STATE.HOVER, [colors.C_SECONDARY_RED_5, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.TERTIARY, BUTTON_STATE.SELECTED, [colors.C_SECONDARY_RED, colors.C_WHITE_100]),
  ...addButtonTheme(BUTTON_THEME.RED, BUTTON_TYPE.TERTIARY, BUTTON_STATE.DISABLED, [colors.C_BLACK_30, colors.C_WHITE_100])
  // /* icon-tosca */
  // ...addButtonTheme(BUTTON_THEME.ICON_TOSCA, BUTTON_STATE.DEFAULT, [
  //   colors.C_BLACK_60,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_TOSCA, BUTTON_STATE.HOVER, [
  //   colors.C_BLACK_80,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_TOSCA, BUTTON_STATE.SELECTED, [
  //   colors.C_BLACK_100,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_TOSCA, BUTTON_STATE.DISABLED, [
  //   colors.C_BLACK_30,
  //   colors.C_WHITE_100,
  // ]),
  // /* black-icon */
  // ...addButtonTheme(BUTTON_THEME.ICON_BLACK, BUTTON_STATE.DEFAULT, [
  //   colors.C_BLACK_60,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_BLACK, BUTTON_STATE.HOVER, [
  //   colors.C_BLACK_80,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_BLACK, BUTTON_STATE.SELECTED, [
  //   colors.C_BLACK_100,
  //   colors.C_WHITE_100,
  // ]),
  // ...addButtonTheme(BUTTON_THEME.ICON_BLACK, BUTTON_STATE.DISABLED, [
  //   colors.C_BLACK_30,
  //   colors.C_WHITE_100,
  // ]),
});
// #endregion